<template>
  <div id="forgetPassword">

    <mt-header title="忘记密码" style="height: 50px">
      <router-link to="/" slot="left">
        <mt-button>
          <img src="../../../assets/icon/back.png" height="auto" width="8px" slot="icon" style="margin-left: 12px">
        </mt-button>
      </router-link>

    </mt-header>
    <hr style="height: 1px;background-color: #d8d8d8;"/>

    <div class="forgetPassword-content">
      <div class="textfield-view">
        <input type="text"
               style="color:#191919"
               v-model="phonteNum"
               placeholder="手机号码"
               class="textfield"/>
        <hr style="height: 1px;background-color: #666666;"/>
      </div>

      <div class="textfield-view textfield-view2">
        <span class="textfield-view2-left">
          <input type="text"
                 style="color:#191919"
                 v-model="sms"
                 placeholder="短信验证码"
                 class="textfield"/>
          <hr style="height: 1px;background-color: #666666;"/>
        </span>
        <span v-bind:class="codeBtnClass" @click="getCode">
          {{codeBtnValue}}
        </span>


      </div>

      <div class="button" @click="nextEvent">
        下一步
      </div>

    </div>


  </div>
</template>

<script>
  //  import { MessageBox } from 'mint-ui'
  import api from '../../../api/common/api.common'
  export default {
    name: 'forgetPassword',
    mounted () {
    },
    destroyed () {
    },
    computed: {
    },
    data () {
      return {
        codeBtnValue: '获取验证码',
        codeBtnClass: 'textfield-view2-right',
        phonteNum: '',
        sms: ''
      }
    },
    methods: {
      getCode (sender) {
        if (!this.utils.isMobileNum(this.phonteNum)) {
          this.utils.alert('请填写正确的手机号')
          return
        }

        var self = this
        var data = {}
        data.mobilePhone = this.phonteNum
        data.verifyCodeType = 1
        api.getAuthCode(data,function () {
          let sec =60;
          self.codeBtnClass = 'textfield-view2-right codeBtn-disabled'
          for(let  i=0; i<=60; i++){
            window.setTimeout(function(){
              if (sec != 0) {
                self.codeBtnValue =   sec + "秒" ;
                sec--;
              } else {
                sec = 60;//如果倒计时结束就让  获取验证码显示出来
                self.codeBtnValue = '获取验证码'
                self.codeBtnClass = 'textfield-view2-right'
              }
            }, i * 1000)
          }
        })
      },
      nextEvent () {
        if (!this.utils.isMobileNum(this.phonteNum)) {
          this.utils.alert('请填写正确的手机号')
          return
        }

        if (this.sms.length > 6 || this.sms.length === 0) {
          this.utils.alert('验证码输入错误')
          return
        }

        var self = this
        var data = {
          mobilePhone:this.phonteNum,
          verifyCode:this.sms,
          verifyCodeType:1
        }

        api.verifySMS(data,function (respond) {
          self.$router.push({path: '/resetPassword',query: {mobilePhone:self.phonteNum}})
        })

//        this.$router.push({path: '/resetPassword',query: {mobilePhone:this.phonteNum,verifyCode:this.sms}})
      }
    }
  }
</script>

<style lang="scss">
  @import '../../../assets/css/mixin';


  .forgetPassword-content {
    margin-top: pxToRem(60px);
  }

  .textfield-view {

    margin-left: pxToRem(52px);
    margin-right: pxToRem(52px);
  }
  .textfield-view2 {
    display: flex;
    justify-content: space-between;
  }
  .textfield-view2-left {
    width: pxToRem(416px);
  }
  .textfield-view2-right {
    width: pxToRem(180px);
    text-align: center;
    /*line-height: pxToRem(76px);*/
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: pxToRem(43px);
    border:solid 1px  #191919;
  }

  .textfield {
    margin-top: pxToRem(60px);
    margin-bottom: pxToRem(30px);
    width: 100%;
  }
  .button {
    background: #3D2D23;
    height: pxToRem(100px);
    line-height: pxToRem(100px);
    text-align: center;
    color: white;
    margin-left: pxToRem(52px);
    margin-right: pxToRem(52px);
    margin-top: pxToRem(80px);
    font-size: pxToRem(28px);
  }
  .codeBtn-disabled {
    pointer-events: none;
    cursor: default;
    opacity: 0.6;
  }

</style>


// WEBPACK FOOTER //
// forgetPassword.vue?7508e59f